/**
 * Persisted BPM. The bridge is stateless across restarts (its clock starts at
 * 120 every boot), so the PWA owns the "what tempo was the user last using"
 * value. On every connect we push it to the bridge via `setBpm`.
 */

const KEY = 'opbuttons.bpm';
const DEFAULT_BPM = 120;
const MIN_BPM = 40;
const MAX_BPM = 240;

export function loadBpm(): number {
  if (typeof localStorage === 'undefined') return DEFAULT_BPM;
  const raw = localStorage.getItem(KEY);
  if (raw === null) return DEFAULT_BPM;
  const n = Number(raw);
  if (!Number.isFinite(n)) return DEFAULT_BPM;
  return clampBpm(n);
}

export function saveBpm(bpm: number): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(KEY, String(clampBpm(bpm)));
}

export function clampBpm(bpm: number): number {
  return Math.max(MIN_BPM, Math.min(MAX_BPM, Math.round(bpm)));
}

export const BPM_RANGE = { min: MIN_BPM, max: MAX_BPM } as const;
